import {
  XhrRequestOptions,
  requestPuppy,
} from '@wix/da-http-client/pkg/request';
import { AxiosRequestConfig } from 'axios';
import { call, select } from 'redux-saga/effects';
import { getProfileGruser } from '../selectors/users';
import { Gruser } from '@wix/da-gruser-shared/pkg/types/papi';

export function* requestPuppyGruser(
  options: XhrRequestOptions,
  fakeResponse?: (requestOptions: AxiosRequestConfig) => any,
  papiBase: string = 'dashared'
) {
  const gruser: Gruser = yield select(getProfileGruser);

  if (options.data) {
    options.data = {
      gruserid: gruser.gruserId,
      gruser_typeid: gruser.gruserTypeid,
      ...options.data,
    };
  }
  if (options.params) {
    options.params = {
      gruserid: gruser.gruserId,
      gruser_typeid: gruser.gruserTypeid,
      ...options.params,
    };
  }
  return yield call(requestPuppy, options, fakeResponse, papiBase);
}
